<template>
  <div>
    <vs-button
      radius
      class="mb-1"
      style="opacity: 0.5"
      color="dark"
      type="line"
      icon="edit_location"
      v-b-modal.Setting_Location
    />
    <b-modal id="Setting_Location" centered size="lg">
      <template #modal-title>
        <h3>Adding Location</h3>
      </template>

      <template>
        <vs-row vs-w="12">
          <vs-col vs-lg="5" class="mt-5 pl-5">
            <vs-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              @on-success="successUpload"
            />
          </vs-col>

          <vs-col vs-lg="7">
            <vs-row>
              <p class="mt-2">Location Name</p>

              <div class="ml-4">
                <!-- <input type="text" class="input" style="width: 150%"  /> -->
                <vs-input class="inputx" v-model="value1" />
              </div>
            </vs-row>

            <br />
            <vs-row>
              <p class="mt-2 ml-4 pl-3">Province</p>

              <vs-select class="selectExample ml-4" v-model="select2">
                <vs-select-item
                  :key="item.id"
                  :value="item.id"
                  :text="item.name_th"
                  v-for="item in provinces"
                />
              </vs-select>
            </vs-row>
            <br />
            <vs-row>
              <p class="mt-2 ml-4">Description</p>

              <div class="ml-4">
                <textarea
                  class="textareainsideshadow"
                  style="width: 160%;padding-left:10px; padding-top:5px"
                  v-model="textarea1"
                />
              </div>
            </vs-row>
          </vs-col>
        </vs-row>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <vs-button @click="updateLocation">Submit</vs-button>
        </vs-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    locationselect: Object,
    provinces: Array,
  },
  data() {
    return {
      value1: this.locationselect.location_name,
      select2: this.locationselect.province_id,
      textarea1: this.locationselect.description,
      // { "id": 6, "location_name": "ปิ้งย่าง", "description": null, "customer_id": null, "province_id": null, "users_id": 177 }
    };
  },
  methods: {
    updateLocation() {
      let data = {
        location_name: this.value1,
        province_id: this.select2,
        description: this.textarea1,
        id : this.locationselect.id
      };
      this.$API.post("location/update", data).then((res) => {
        if (res.status == 200) {
          this.$vs.notify({
            title: "Update location",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
          this.$bvModal.hide("Add_Location");
          location.reload();
        } else if (res.status != 200)
          this.$vs.notify({
            title: "Update location",
            text: res.data.message,
            color: "danger",
            position: "top-center",
          });
      });
    },
  },
};
</script>

<style></style>
